/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { R300 } from '@atlaskit/theme/colors';
import { messages } from '../../../messages';
import { gs } from '../../common/utils';
import { Frame } from '../components/ErrorFrame';
var messageStyles = css({
  font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  fontWeight: "var(--ds-font-weight-regular, 400)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  marginLeft: gs(0.5),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  marginRight: gs(0.5),
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  // Fallback options.
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  maxHeight: gs(3)
});
var boxStyles = xcss({
  paddingLeft: 'space.050',
  paddingRight: 'space.050'
});
export var EmbedCardErroredView = function EmbedCardErroredView(_ref) {
  var onRetry = _ref.onRetry,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'embed-card-errored-view' : _ref$testId,
    inheritDimensions = _ref.inheritDimensions;
  return jsx(Frame, {
    inheritDimensions: inheritDimensions,
    compact: true,
    isSelected: isSelected,
    testId: testId
  }, jsx(ErrorIcon, {
    LEGACY_size: "small",
    color: "var(--ds-icon-danger, ".concat(R300, ")"),
    label: "error-icon"
  }), jsx(Box, {
    xcss: boxStyles
  }, jsx(Inline, {
    xcss: messageStyles
  }, jsx(FormattedMessage, messages.could_not_load_link))), jsx(Button, {
    testId: "err-view-retry",
    appearance: "link",
    spacing: "none",
    onClick: onRetry
  }, jsx(FormattedMessage, messages.try_again)));
};